import { Drawer } from "antd";
import React from "react";
import WaterMarker from "../../../../../Components/WaterMarker";
import SubArea from "./components/mapa";
import { ItensPerUserLogged } from "../../../../../services/login/permissaoUsuarioLoado";

interface PropsMostrarSubArea {
  codPropri: number
  onClose: (data: boolean) => void
  listTalhoesRecord: any[]
  listTalhaoSafra: (data: number) => void
  update: number
  permissions: ItensPerUserLogged
  visible: boolean
   editIndexSubTalhao: number
   setEditIndexSubTalhao: React.Dispatch<React.SetStateAction<number>>
}

export const MostrarSubArea: React.FC<PropsMostrarSubArea> = ({
  codPropri,
  onClose,
  listTalhaoSafra,
  listTalhoesRecord,
  update,
  permissions,
  visible,
  editIndexSubTalhao,
  setEditIndexSubTalhao
}) => {
  return (
    <Drawer
        forceRender
        open={visible}
        placement='bottom'
        headerStyle={{ display: 'none' }}
        width='100%'
        closeIcon={false}
        contentWrapperStyle={{ minHeight: '100%' }}
        bodyStyle={{ overflow: 'hidden', padding: 0 }}
      >
        <SubArea
          propriedade={codPropri}
          onClose={onClose}
          listTalhoesRecord={listTalhoesRecord}
          listTalhaoSafra={listTalhaoSafra}
          update={update}
          permissions={permissions}
          visible={visible}
          editIndexSubTalhao={editIndexSubTalhao}
          setEditIndexSubTalhao={setEditIndexSubTalhao}
        />
        <WaterMarker placement='bottomRight' />
      </Drawer>
  )
}